import { IFormattedFinanceOptions } from 'cng-common/helpers/numbers'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

export type TSobReportSalesType = 'Net' | 'Ndp' | 'TNet' | 'UTNet'

export const DEFAULT_SELL_TYPES_OPTIONS: ActualsValueTypes[] = [
  ActualsValueTypes.UTNet,
  ActualsValueTypes.TNet,
  ActualsValueTypes.Net,
  ActualsValueTypes.Ndp,
]

export const SELL_TYPE_FORM_FIELD = 'sellType'

export const PREV_QUARTERS_MAPPER: Record<string, number[]> = {
  '1': [4],
  '2': [1],
  '3': [2],
  '4': [3],
  '1,2': [3, 4],
  '3,4': [1, 2],
  '1,2,3': [2, 3, 4],
  '1,2,3,4': [1, 2, 3, 4],
}

export const QUARTERS_IN_CHART = 8
export const QUARTER = 4

export const FINANCIAL_VALUE_FORMAT_OPTIONS: IFormattedFinanceOptions = {
  maximumFractionDigits: 1,
  minimumFractionDigits: 1,
}
